import { MenuType } from "./EditorNavUtils";

export const MenuItemType = {
  Page: 1,
  External_Link: 2,
  Email: 3,
  Phone: 4,
  Folder: 5,
};

export const menuLinkWithSubAttrs = {
  role: "button",
};

export function getLinkProps(menuItem) {
  if (menuItem.type_id === MenuItemType.External_Link) {
    const href = menuItem.value;
    return { href };
  }

  if (menuItem.type_id === MenuItemType.Phone) {
    const href = `tel:${menuItem.value}`;
    return { href };
  }

  if (menuItem.type_id === MenuItemType.Email) {
    const href = `mailto:${menuItem.value}?subject=${
      menuItem.email_subject || ""
    }`;
    return { href };
  }

  if (menuItem.type_id === MenuItemType.Folder) {
    return {};
  }

  // if menuItem.type_id === MenuItemType.Page or else
  const page = {
    id: menuItem?.page?.id || menuItem.value || menuItem?.id,
    name: menuItem?.page?.name || menuItem?.name || menuItem?.title,
  };
  return { page, href: "#" };
}

export function getMenuItems(props) {
  // as we didn't migrate published sites on MongoDB
  // I am going to render the old pages.
  if (props.menuItems?.[0]?.path || props.menuItems?.[0]?.home_page) {
    return props.pages;
  }

  const isFooter = !!props?.onlyTopLevel;
  if (isFooter) {
    const items = props.menuItems?.filter((i) => i.menu_id === MenuType.Footer);
    return items || [];
  }

  // if header
  const items = props?.menuItems?.filter((i) => i.menu_id === MenuType.Header);
  return items || [];
}
